import React from 'react';

interface SidebarIconProps {
    icon: React.ReactNode;
    text: string;
}

const SidebarIcon: React.FC<SidebarIconProps> = ({ icon, text }) => {
    return (
        <div className="sidebar-icon group">
            <span aria-hidden="true">{icon}</span>
            <span className="sidebar-pageName group-hover:scale-100 z-50">
                {text}
            </span>
        </div>
    );
};

export default SidebarIcon;

